<div class="card-level-info-display">
  <a [routerLink]="['/free/worksheets']"><img src="/assets/images/level-info/boldungu_usecase0_800x600.png" alt="Avatar" style="width:98%"></a>
    <div class="container">
      <h4><b>Weekly Teachers Pick</b></h4>
      <p>Weekly Hands on activities by Mail </p>
      <table class="table">
        <tr>
          <td>
            <a [routerLink]="['/free/worksheets']"> Free Worksheets and More</a>
          </td>
          <td>
            <a [routerLink]="['/free/worksheets']">Hands On activities</a></td>

        </tr>
      </table>
    </div>
  </div>
